import * as React from "react"
import BaseController from "../base-controller"
import Features from "../components/base/Features"

// markup
class FeaturesR extends React.Component {
    render() {
        return (
            <BaseController>
                <section class="text-center">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-md-8 col-lg-6">
                                <div class="cta">
                                    <h2>Explore Popupfox Features</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Features />
            </BaseController>
        )
    }
}

export default FeaturesR
